import React from 'react'

import FlexGrid from '../../../../components/structure/FlexGrid'
import RelatedRepliesLoader, { useReplies } from './_load/RelatedRepliesLoader'
import Reply from './Reply'

const RelatedReplies = () => {
  const replies = useReplies()
  return (
    <FlexGrid gutter={0.3} direction="column" align="stretch">
      {replies.map(reply => (
        <Reply key={reply.id} item={reply} />
      ))}
    </FlexGrid>
  )
}

const Wrapper = ({ reply }) => {
  return (
    <RelatedRepliesLoader reply={reply}>
      <RelatedReplies />
    </RelatedRepliesLoader>
  )
}

export default Wrapper
